module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_75-8dfcd5c0c061d7878dda6a9a5e6c1434.png";